export enum Categories {
  Home = 'home',
  Test = 'test',
  TestRun = 'test-run',
  VariableSet = 'variable-set',
  TraceAnalyzer = 'trace-analyzer',
  TraceDetail = 'trace-detail',
  TestResults = 'test-results',
  SpanDetail = 'span-detail',
  Assertion = 'assertion',
  Wizard = 'wizard',
}

export enum Labels {
  Button = 'button',
  Link = 'link',
  Modal = 'modal',
  Table = 'table',
  Form = 'form',
  Tab = 'tab',
  Input = 'input',
}
